import {
  DimensionDescriptor,
  MeasureDescriptor,
  MetaItemType,
  MetricDescriptor,
} from "../../../../../shared/reporting/api/biClient.types";

export const isReferenceDateField = (meta: DimensionDescriptor | MeasureDescriptor | MetricDescriptor) => {
  if (meta.itemType === MetaItemType.DIMENSION) {
    return meta.options?.asDateReference === true;
  }

  return false;
};
